// ©2024 Austin App House. All rights reserved.
import React, { useContext, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  sendContractorRate,
  setSortType,
  setSearchObject,
} from '../storage/actions/workOrdersActions';
import { toggleModal } from '../storage/actions/modalsActions';
import Offer from '../components/layout/Offer';
import DashboardContent from '../components/dashboard/DashboardContent';
import { SocketContext } from '.';

const Dashboard = ({
  profile,
  workOrder,
  location,
  toggleModal,
  sendContractorRate,
  setSortType,
  setSearchObject,
  useIntercom,
  history,
  match
}) => {
  // Array of Work Order ID`s prepared to export
  const { notificationSocket: socket } = useContext(SocketContext);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    socket && socket.on('notification', (response) => {
      console.log(response);
    });
  }, [socket]);

  useEffect(() => {
    document.body.classList.add('dashboard-body');
    return () => document.body.classList.remove('dashboard-body');
  }, []);

  const processedSearchRef = useRef('');

  useEffect(() => {
    if (!location.search) {
      processedSearchRef.current = '';
      return undefined;
    }

    if (processedSearchRef.current === location.search) {
      return undefined;
    }

    processedSearchRef.current = location.search;
    const params = new URLSearchParams(location.search);
    const typeParameter = params.get('type');

    switch (typeParameter) {
      case 'work-order':
        toggleModal(true, 'viewDetailsWorkOrderModal', true, {
          id: params.get('id'),
          win: params.get('win'),
        });
        break;
      case 'contractor':
        toggleModal(true, 'contractorDetailsModal', false, { contractorId: params.get('id') });
        break;
      case 'thank_you_for_rate':
        sendContractorRate({
          id: params.get('id'),
          rate: params.get('rate'),
        });
        break;
      default:
        break;
    }

    return undefined;
  }, [location.search]);

  return (
    <>
      <main className="dashboard-main">
        <Offer
          getSearched={setSearchObject}
        />
        <DashboardContent
            filters={workOrder.filters}
            search={workOrder.searchData}
            sortBy={workOrder.sortBy}
            setSort={setSortType}
            sortType={workOrder.sortBy?.sortType}
            useIntercom={useIntercom}
            profile={profile}
          />
      </main>
    </>
  );
};

const mapDispatchToProps = {
  toggleModal,
  sendContractorRate,
  setSortType,
  setSearchObject,
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile,
  workOrder: state.workOrder,
});

export default connect(
  mapStateToProps, mapDispatchToProps,
)(withRouter(Dashboard));
